<div class="flex h-full min-h-0 w-full flex-col overflow-hidden">
  <header class="shrink-0 border-b border-zinc-200 pb-4 dark:border-zinc-800">
    <div class="min-w-0">
      <h2 class="m-0 text-lg font-semibold text-zinc-900 dark:text-zinc-100">Buttons</h2>
      <p class="m-0 mt-1 text-sm text-zinc-500 dark:text-zinc-400">
        Shared button classes from the design system. Classes below each sample are what you apply in
        templates. Use the toggle on a card to preview enabled and disabled styling.
      </p>
    </div>
  </header>

  <div class="min-h-0 flex-1 overflow-y-auto pt-5 scrollbar-transparent">
    <div class="flex flex-col gap-8">
      @for (group of groups; track group.id) {
      <section [attr.aria-labelledby]="'button-group-' + group.id">
        <h3 class="m-0 text-sm font-semibold text-zinc-900 dark:text-zinc-100" [id]="'button-group-' + group.id">
          {{ group.title }}
        </h3>
        <p class="m-0 mt-1 text-xs text-zinc-500 dark:text-zinc-400">{{ group.description }}</p>

        <div class="mt-3 grid grid-cols-1 gap-3 sm:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4">
          @for (sample of group.samples; track sample.id) {
          <article
            class="flex flex-col rounded-xl border border-zinc-200 bg-white p-4 dark:border-zinc-800 dark:bg-zinc-950">
            <div class="flex min-h-16 items-center justify-center">
              <button type="button" [class]="sample.classes"
                [disabled]="disabledSampleIds().has(sample.id)"
                [attr.aria-label]="sample.kind === 'icon' ? sample.label : null">
                @if (sample.kind === 'icon') {
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-5"
                  aria-hidden="true">
                  <path d="M5 12h14" />
                  <path d="M12 5v14" />
                </svg>
                } @else {
                {{ sample.label }}
                }
              </button>
            </div>
            <code
              class="mt-3 block wrap-break-word rounded-md bg-zinc-100 px-2 py-1.5 text-center text-xs leading-5 text-zinc-700 dark:bg-zinc-900 dark:text-zinc-300">{{ sample.classes }}</code>

            <div class="mt-3 flex items-center justify-center gap-2">
              <p class="m-0 text-xs text-zinc-500 dark:text-zinc-400">
                {{ disabledSampleIds().has(sample.id) ? 'Disabled' : 'Enabled' }}
              </p>
              <app-toggle [options]="buttonStateOptions" [selectedOption]="selectedOptionFor(sample.id)"
                (selectedOptionChange)="onToggle(sample.id, $event)">
              </app-toggle>
            </div>
          </article>
          }
        </div>
      </section>
      }
    </div>
  </div>
</div>
